import { forkJoin, Observable } from 'rxjs';
import { USER_ID_KEY } from '../constants';
import { AuthService, StorageService } from '../services';
import { PermissionService } from '../services/permissions';

export function initializeAppFactory(
  authService: AuthService,
  permissionService: PermissionService
): () => Observable<unknown> {
  const isUserLogged = !!StorageService.GetItem(USER_ID_KEY);

  if (!isUserLogged) {
    const el = () =>
      new Observable((obs) => {
        obs.next(null);
        obs.complete();
      });

    return el;
  }

  const permissions$ = permissionService.findAll();
  const userRequest$ = authService.handleUserRequest();

  return () => forkJoin([permissions$, userRequest$]);
}
